export function getFirstCharacter(name: string): string {
  return name && name.charAt(0).toUpperCase()
}
